import styled, { css } from 'styled-components';
import flash from '~/assets/icons/flash.svg';
import { Text } from '~/components/ui/Text';
import loseBg from '../../assets/images/lose_bg.png';
import winBg from '../../assets/images/win_bg.png';

const StyledCenterBlock = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 20px;

	${Text} {
		font-weight: 700;
		font-size: 20px;
		text-align: center;
		letter-spacing: 0.4em;
		color: #ff0000;
	}
`;

const StyledResultIconContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 40px;
	height: 40px;
	border-radius: 10px;
`;

const StyledResultIcon = styled.div`
	width: 20px;
	height: 20px;
	mask-image: url(${flash});
	mask-position: center;
	mask-repeat: no-repeat;
	mask-size: contain;
	-webkit-mask-image: url(${flash});
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
	-webkit-mask-size: contain;
	background-color: #111111;
`;

const StyledContainer = styled.div<{ $type: 'win' | 'lose' }>`
	position: fixed;
	top: 21px;
	left: 22px;
	width: 1020px;
	height: 680px;
	z-index: 25;
	border-radius: 30px;
	background-image: ${({ $type }) =>
		$type === 'win' ? `url(${winBg})` : `url(${loseBg})`};
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	transition: opacity 0.3s;
	opacity: 0;
	overflow: hidden;

	&.overlay-enter {
		opacity: 0;
	}

	&.overlay-enter-active,
	&.overlay-enter-done,
	&.overlay-exit {
		opacity: 1;
	}

	&.overlay-exit-active {
		opacity: 0;
	}

	${({ $type }) =>
		$type === 'win'
			? css`
					${StyledCenterBlock} {
						${Text} {
							color: #00ff1e;
						}
					}

					${StyledResultIconContainer} {
						background-color: #00ff1e;
					}
			  `
			: css`
					${StyledCenterBlock} {
						${Text} {
							color: #ff0000;
						}
					}

					${StyledResultIconContainer} {
						background-color: #ff0000;
					}
			  `}
`;

const StyledBottomText = styled(Text)`
	position: absolute;
	left: 50%;
	bottom: 40px;
	transform: translateX(-50%);
	font-size: 12px;
	color: #ffffff;
	opacity: 0.1;
`;

export {
	StyledBottomText,
	StyledCenterBlock,
	StyledContainer,
	StyledResultIcon,
	StyledResultIconContainer,
};
